module.exports = __webpack_public_path__ + "img/jsApiPay.feea15bb.png";